export default __webpack_public_path__ + "static/media/cidi.50aa7d1d.png";